const holder = {
  closeDropdownSelector(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", holder.closeDropdownSelector)
    }
  }
};

export default {
  'TotalCostDropdown.Selector': async ({ isOpen, containerRef }, _, internalStateSetter) => {
    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = containerRef;

    await internalStateSetter({ isOpen: !isOpen });

    if (isOpen) {
      document.removeEventListener("mousedown", holder.closeDropdownSelector);
    } else {
      document.addEventListener("mousedown", holder.closeDropdownSelector);
    }

  },
  'TotalCostDropdown.DropdownWrapper.BorderWrapper.ListWrapper.Errors.RightSide.Down': ({ messageIndex, inspection }, _, internalStateSetter) => {
    if (messageIndex < inspection.items.filter(i => (!i.posted_on || i.post_error) && i.options.find(o => o.name === i.status)?.cost_in_cents > 0).length) {
      internalStateSetter({ messageIndex: messageIndex + 1 })
    }
  },
  'TotalCostDropdown.DropdownWrapper.BorderWrapper.ListWrapper.Errors.RightSide.Up': ({ messageIndex }, _, internalStateSetter) => {
    if (messageIndex > 0) {
      internalStateSetter({ messageIndex: messageIndex - 1 })
    }
  },
  'TotalCostDropdown.DropdownWrapper.BorderWrapper.ButtonsWrapper.Export': ({ }, outlet) => {
    outlet({ action: 'export_charges' })
  },
  'TotalCostDropdown.DropdownWrapper.BorderWrapper.ButtonsWrapper.Button': ({ disabled }, outlet, internalStateSetter) => {
    if (disabled) return;
    internalStateSetter({ messageIndex: 0 })
    outlet({ action: 'post_charges' })
  },
}